export const ModalCommonClasses = 'w-maxContent h-maxContent m-auto';
